import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
     <h3>"Begin, be bold, and adventure to be wise"</h3>
      <p>Horace</p>
    </div>
    <div className="gpt3__cta-btn">
     
      <a href="https://gls-oracle.vercel.app/">
         <button type="button">Visit Site</button>   
       </a>
    </div>
  </div>
);

export default CTA;